import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { SecondaryBody } from '@grnhse/seedling/lib/birch/typography';
import { withLocalePrefix } from 'shared/utils/translation';
import {
  matchCategoryColor,
  CategoryValue,
} from 'talent_matching/components/shared/match_category';
import type { MatchReport } from 'talent_matching/types';

const t = withLocalePrefix('talent_matching.table.columns.match_report');

const DIMENSIONS: {
  attrKey: 'skills_category' | 'work_history_category' | 'education_category';
  labelKey: string;
}[] = [
  { attrKey: 'skills_category', labelKey: 'skills' },
  { attrKey: 'work_history_category', labelKey: 'experience' },
  { attrKey: 'education_category', labelKey: 'education' },
];

type Props = {
  matchReport?: MatchReport | null;
};

const MatchReportCell = ({ matchReport }: Props) => {
  const attributes = matchReport?.attributes;
  const hasAny =
    attributes && DIMENSIONS.some(({ attrKey }) => attributes[attrKey]);

  if (!attributes || !hasAny) {
    return <SecondaryBody>{'--'}</SecondaryBody>;
  }

  return (
    <Stack spacing={0.5} sx={{ padding: 1, paddingLeft: 0, height: '100%' }}>
      {DIMENSIONS.map(({ attrKey, labelKey }) => {
        const value = attributes[attrKey];
        return (
          <Stack
            key={attrKey}
            direction="row"
            spacing={1}
            justifyContent="space-between"
          >
            <SecondaryBody metadata>{t(labelKey)}</SecondaryBody>
            {value ? (
              <CategoryValue metadata $color={matchCategoryColor(value)}>
                {value}
              </CategoryValue>
            ) : (
              <SecondaryBody metadata>{'--'}</SecondaryBody>
            )}
          </Stack>
        );
      })}
    </Stack>
  );
};

export default MatchReportCell;
